// extracted by mini-css-extract-plugin
export var assigneeBadge = "_lr-0";
export var assigneeDetails = "_lr-1";
export var assigneeInfo = "_lr-2";
export var dropdownContainer = "_lr-4";
export var dropdownImage = "_lr-5";
export var editAssigneeInfo = "_lr-3";
export var editAssigneeModalContainer = "_lr-6";
export var hidden = "_lr-8";
export var input = "_lr-7";